import { render, staticRenderFns } from "./indexNotice.vue?vue&type=template&id=22a32f8a&scoped=true"
import script from "./indexNotice.vue?vue&type=script&lang=js"
export * from "./indexNotice.vue?vue&type=script&lang=js"
import style0 from "./indexNotice.vue?vue&type=style&index=0&id=22a32f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a32f8a",
  null
  
)

export default component.exports